<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> {{title}}
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="container">
        <div class="row form-group row-form-add" >
            <div class="headline form-style">Colleague Information </div>

        <div class="col-md-12 form-group">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="coll_name">Colleague Name: </div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <input v-model="coll_name" type="text" class="form-control" id="coll_name" name="coll_name" placeholder="Colleague Name" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{coll_nameError}}</font>
                                </div>
          </div>

          <div class="col-md-12 form-group">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="pref_name">Preferred Name:</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <input v-model="pref_name" type="text" class="form-control" id="pref_name" placeholder="Preferred Name" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{pref_nameError}}</font>
                                </div>
          </div>

          <div class="col-md-6 form-group">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="coll_pronouns">Preferred Pronouns:</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                        <select v-model="coll_pronouns" @input="changedValuepronouns()"  id="coll_pronouns" name="coll_pronouns" class="form-control">
                                          <option disabled value="">Please select one</option>
                                          <option>He/Him</option>
                                          <option>She/Her</option>
                                          <option>They/Them</option>
                                        </select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{coll_pronounsError}}</font>
                                </div>
          </div>

          <div class="col-md-6 form-group">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="orcoll_pronouns">or input your own:</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <input v-model="orcoll_pronouns" @input="changedValuepronouns()" type="text" class="form-control" id="orcoll_pronouns" placeholder="Preferred Pronouns" />
                                    <!--<div class="requiredstar">*</div>-->
                                    <!--<font class="text-danger">{{orcoll_pronounsError}}</font>-->
                                </div>
          </div>

          <div class="col-md-12 form-group  ">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="dept_func">Dept/Job Function:</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <input v-model="dept_func" type="text" class="form-control" id="dept_func" placeholder="Dept/Job Function" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{dept_funcError}}</font>
                                </div>
          </div>

          <div class="col-md-12 form-group ">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="email">Email:</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <input type="email" v-model="email" class="form-control" id="email" placeholder="Enter email" name="email">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{emailError}}</font>
                                </div>
          </div>

          <div class="col-md-12 form-group ">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="emp_id">Employee ID:</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <input v-model="emp_id" type="text" class="form-control" id="emp_id" placeholder="Employee ID" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{emp_idError}}</font>
                                </div>
          </div>

          <div class="col-md-12 form-group ">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="location">Location:</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <input v-model="location" type="text" class="form-control" id="location" placeholder="Location" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
          </div>

          <div class="col-md-12 form-group">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="interest_reason">What’s the primary reason you’re interested in joining this ERG?</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <textarea v-model="interest_reason" type="text" class="form-control" id="interest_reason" placeholder="What’s the primary reason you’re interested in joining this ERG?"></textarea>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{interest_reasonError}}</font>
                                </div>
          </div>

          <div class="col-md-12 form-group">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label" for="interest_topic">Are there topics/events you are interested in seeing from this group?</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <textarea v-model="interest_topic" type="text" class="form-control" id="interest_topic" placeholder="Are there topics/events you are interested in seeing from this group?"></textarea>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{interest_topicError}}</font>
                                </div>
          </div>

          <div class="col-md-6 form-group">
                                <div class="col-md-8 paddingleft0">
                                    <div class="form-label" for="skill_sets">What skill-sets and strengths do you wish to contribute
                                    to this group?</div>
                                </div>
                                 <div class="col-md-4 paddingleft0">
                                    <input type="checkbox" class="form-checkbox-custom" @input="changedValueskill()" v-model="skill_sets" value="Communications" id="communications">
                                    <label class="form-checkbox-custom-label" for="communications">Communications</label>

                                    <input type="checkbox" class="form-checkbox-custom" @input="changedValueskill()" v-model="skill_sets" value="Graphic Design" id="graphic">
                                    <label class="form-checkbox-custom-label" for="graphic">Graphic Design</label>

                                    <input type="checkbox" class="form-checkbox-custom" @input="changedValueskill()" v-model="skill_sets" id="analytics" value="Analytics">
                                    <label class="form-checkbox-custom-label" for="analytics">Analytics</label>

                                    <input type="checkbox" class="form-checkbox-custom" @input="changedValueskill()" v-model="skill_sets" id="event" value="Event Operations">
                                    <label class="form-checkbox-custom-label" for="event">Event Operations</label>

                                    <input type="checkbox" class="form-checkbox-custom" @input="changedValueskill()" v-model="skill_sets" id="group" value="Group Operations">
                                    <label class="form-checkbox-custom-label" for="group">Group Operations</label>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{skill_setsError}}</font>
                                </div>
          </div>
          <div class="col-md-6 form-group">
                                <div class="col-md-3 paddingleft0">
                                    <div class="form-label"  for="orskill_sets">or input your own:</div>
                                </div>
                                <div class="col-md-9 paddingleft0">
                                    <input v-model="orskill_sets" type="text" @input="changedValueskill()" class="form-control" id="orskill_sets" placeholder="or input your own" />
                                    <!--<div class="requiredstar">*</div>-->
                                    <!--<font class="text-danger">{{orskill_setsError}}</font>-->
                                </div>
          </div>

          <div class="col-md-6 form-group">

        <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateSurveys()">
        <input id="back_button" type="submit" value="Back" class="btn btn-danger" v-on:click.prevent="buttonBack">

        </div>
        </div>
        </div>


        <!--End internal page banner section-->
        <div class="internal-page-main-section survey-section-main col-12 employee-resource">
            <div class="container">
                <div class="row">
                    <div class="survey-main-section col-12 float-l">
                        <div class="row">
                            <div class="">
                                <template v-for="(text, index) in surveyList">
                                <div class="survey-detail-section col-12 col-sm-4 col-md-4 col-lg-4"> <!--first-->
                                    <div class="survey-inner-sec">
                                        <div class="survey-title float-l width-full">
                                            <h3> {{text.title}} </h3>
                                        </div>
                                        <div class="survey-img float-l width-full relative">

                                            <a v-on:click="openCalendar(text.slug,text.hr_id)">
                                            <!--  :href="'calender/' + text.slug + '?location='+locationId.value"  -->
                                              <img class="width-full" :src="text.image_path" alt="ERG">

                                              <template v-if="text.hr_id == user_id || allow_create_erg_calendar_event">
                                                <div class="overlay">
                                                    <div class="text">
                                                        <img src="/static/images/calendar-icon.png" style="height: auto;" width="66">
                                                    </div>
                                                </div>
                                              </template>
                                            </a>

                                        </div>
                                        <div class="survey-short-des float-l width-full">
                                            <p v-html="text.description"></p>
                                        </div>

                                        <div class="survey-pdf-section float-l width-full">
                                            <template v-if="(text.attachment_path != null) && (text.attachment_path != '')">
                                                <a :href="text.attachment_path" target="_blank"> {{text.title}} Form </a>
                                            </template>

                                            <!--template v-for="(btn, index) in text.button_array">
                                            <a :href="btn.button_url" target="_blank"> {{btn.button_title}} </a>
                                            </template-->
                                        </div>
                                    </div>
                                </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import VueFrame from 'vue-frame';
    var self;
    export default {
        name: 'Surveys',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'v-frame': VueFrame,
        },
        data() {
            return {
                FirstLoad: true,
                roleId: 0,
                roleArr: [],
                locationId: 0,
                locationArr: [],
                surveyList: [],
                skill_sets:[],
                titleform:'',
                user_id:'',
                coll_name:'',
                coll_nameError:'',
                title:'',
                allow_create_erg_calendar_event:false,
                interest_topic:'',
                interest_reason:'',
                location:'',
                emp_id:'',
                email:'',
                dept_func:'',
                coll_pronouns:'',
                orcoll_pronouns:'',
                orskill_sets:'',
                pref_name:'',
                dept_funcError:'',
                coll_pronounsError:'',
                pref_nameError:'',
                skill_setsError:'',
                interest_topicError:'',
                interest_reasonError:'',
                locationError:'',
                emp_idError:'',


            }
        },
        beforeMount: function () {
            self = this;
            self.role.id = 0;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.getPermissions();
            self.getBuildVersion();
            var user_obj = localStorage.getItem('user_obj');

            self.title=this.$route.params.title;
            self.ergId=this.$route.params.id;


            user_obj = JSON.parse(user_obj);
            self.user_id = user_obj.id;
            $("#email").on('keyup', function () {
                self.emailError = '';
            });
            $("#coll_name").on('keyup', function () {
                self.coll_nameError = '';
            });
            $("#skill_sets").on('keyup', function () {
                self.skill_setsError = '';
            });
            $("#interest_topic").on('keyup', function () {
                self.interest_topicError = '';
            });
            $("#interest_reason").on('keyup', function () {
                self.interest_reasonError = '';
            });
            $("#location").on('keyup', function () {
                self.locationError = '';
            });
            $("#emp_id").on('keyup', function () {
                self.emp_idError = '';
            });
            $("#dept_func").on('keyup', function () {
                self.dept_funcError = '';
            });
            $("#coll_pronouns").on('keyup', function () {
                self.coll_pronounsError = '';
            });
            $("#pref_name").on('keyup', function () {
                self.pref_nameError = '';
            });




            for(var i=0; i<=user_obj.roles.length;i++){
              // console.log(user_obj.roles[i].id);
                    if(user_obj.roles[i].id == 0 || user_obj.roles[i].id == 1)
                    {
                        self.allow_create_erg_calendar_event=true;
                    }
            }
        },
        watch: {
            locationId: function (locationId) {
                self.getSurveyData();
            },
            roleId: function (roleId) {
                // self.getSurveyData();
            }
        },

        methods: {
          buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/erg');
            },
          changedValuepronouns: function () {
                self.coll_pronounsError = "";
            },
            changedValueskill: function () {
                self.skill_setsError = "";
            },
            openCalendar(slug,hr_id) {
              console.log(slug);
              console.log(hr_id);
              console.log(self.user_id);
                // if(hr_id == self.user_id) {
                    let routeData = this.$router.resolve({name: 'ERGCalendar',params:{slug: slug}, query:{data:btoa(self.locationId.value)}});
                    window.open(routeData.href, '_blank');
                // }
            },
            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                    .then(function (response) {
                        self.roleArr = [];
                        var addAll = {text: 'All', value: '0'};
                        //self.roleArr.push(addAll);
                        $.each(response.data.content, function (i) {
                            self.roleArr.push(response.data.content[i]);
                        });
                        self.roleId = addAll;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                        }
                    });
            },
            checkForm: function () {
                var checked = true;
                // if (self.locationId.length === 0) {
                //     self.locationError = "State Required";
                //     if (checked) {
                //         checked = false;
                //     }
                // }
                if (!self.email) {
                    self.emailError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.coll_name) {
                    self.coll_nameError = "Colleague Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.dept_func) {
                    self.dept_funcError = "Dept/Job Function Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.coll_pronouns) {
                    self.coll_pronounsError = "Preferred Pronouns Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.pref_name) {
                    self.pref_nameError = "Preferred Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.skill_sets.length === 0) {
                    self.skill_setsError = "Skill-sets and Strength Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.interest_topic) {
                    self.interest_topicError = "This field is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.interest_reason) {
                    self.interest_reasonError = "This field is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.location) {
                    self.locationError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.emp_id) {
                    self.emp_idError = "Employee Id Required";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },

            getSurveyData() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        role_id: roleId,
                        location_id: locationId,
                    }
                };


            },
            addUpdateSurveys(flag) {
                // alert('here');
                // return ;
                self.checkForm();
                if (self.checkForm()) {
                    /*console.log("form check success");*/
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    console.log("lo == ", self.skill_sets);

                    var data = {
                      skill_sets:self.skill_sets,
                      interest_topic:self.interest_topic,
                      interest_reason:self.interest_reason,
                      location:self.location,
                      emp_id:self.emp_id,
                      email:self.email,
                      dept_func:self.dept_func,
                      coll_pronouns:self.coll_pronouns,
                      orcoll_pronouns:self.orcoll_pronouns,
                      orskill_sets:self.orskill_sets,
                      pref_name:self.pref_name,
                      coll_name:self.coll_name,
                      form_title:self.title,
                      ergid:self.ergId,
                      id: segments[3],
                    };
                    $("#addBenifitBtn").val("Updating ...");
                    $("#addBenifitBtn").prop("disabled", true);
                    // $("#addAndContinueCaseBtn").prop('disabled',true);
                    $("#CancelBenifit").prop("disabled", true);

                    self.showLoader();
                    HTTP.post("addforms", data, config)
                            .then(function (response) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                        //  $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        alert('Form has been added successfully');
                                        self.skill_sets=[],
                                        self.interest_topic='',
                                        self.interest_reason='',
                                        self.location='',
                                        self.emp_id='',
                                        self.email='',
                                        self.dept_func='',
                                        self.coll_pronouns='',
                                        self.orcoll_pronouns='',
                                        self.orskill_sets='',
                                        self.pref_name='',
                                        self.coll_name='',



                                        setTimeout(function () {
                                          $("#addBenifitBtn").val("save");
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 3000);

                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {

                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();

                            })
                            .catch(function (err) {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);

                                    }
                                    self.hideLoader();


                            });
                    }

                },

          }
    }
</script>



// WEBPACK FOOTER //
// src/components/Forms.vue